import React, {useMemo} from 'react';

import {Group} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import Loading, {Types} from '@pb/kit-component-loading';
import {Tooltip} from '@pb/kit-component-popups';

import {HEADERS} from '../../constants';

import type {Error} from 'src/openapi/admin/models/Error';

type ContentBeforeProps = {
    isLoading: boolean,
    loadingError: Error | null,
};

export const HeaderContentBefore = ({isLoading, loadingError}: ContentBeforeProps) => {
    const content = useMemo(() => {
        if (isLoading) {
            return <Loading type={Types.ICON}/>;
        }

        if (loadingError) {
            return (
                <Tooltip
                    anchor={({anchorRef, getAnchorProps}) => (
                        <BasicIconButton ref={anchorRef} {...getAnchorProps()} iconProps={{type: Icons.ERROR}}/>
                    )}>
                    {loadingError.message}
                </Tooltip>
            );
        }

        return null;
    }, [isLoading, loadingError]);

    return content;
};

type Props = ContentBeforeProps & {
    columnId: string,
};

export const HeaderCaption = ({isLoading, loadingError, columnId}: Props) => (
    <Group alignItems="center">
        <HeaderContentBefore isLoading={isLoading} loadingError={loadingError}/>
        <Group>
            <strong>{HEADERS[columnId]}</strong>
        </Group>
    </Group>
);
